/* SIX TALLOW — interacciones (vanilla JS) */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* --- Reveals al hacer scroll --- */
  function initReveals() {
    var els = document.querySelectorAll('.mt-reveal');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('mt-visible'); });
      return;
    }
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('mt-visible'); obs.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { obs.observe(el); });
  }

  /* --- Marquesina: duplica el contenido para bucle perfecto --- */
  function initMarquee() {
    document.querySelectorAll('.mt-tira__track').forEach(function (track) {
      if (track.dataset.mtDone) return;
      track.dataset.mtDone = '1';
      track.innerHTML = track.innerHTML + track.innerHTML;
    });
  }

  /* --- Galería de la página de producto --- */
  function initPdpGallery() {
    var main = document.querySelector('.mt-pdp__main');
    var thumbs = document.querySelectorAll('.mt-pdp__thumb');
    if (!main || !thumbs.length) return;
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        main.src = t.dataset.full || t.src;
        thumbs.forEach(function (x) { x.classList.remove('is-active'); });
        t.classList.add('is-active');
      });
    });
  }

  /* --- Selector de variantes de la página de producto --- */
  function initPdpVariants() {
    var root = document.querySelector('[data-mt-product]');
    if (!root) return;
    var dataEl = root.querySelector('[data-mt-variants]');
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var idInput = root.querySelector('input[name="id"]');
    var priceEl = root.querySelector('[data-mt-price]');
    var addBtn = root.querySelector('[data-mt-add]');
    var btns = root.querySelectorAll('.mt-pdp__variant');
    var moneyFormat = root.getAttribute('data-money') || '${{amount}}';

    function formatMoney(cents) {
      var v = (cents / 100);
      // separador de miles con punto (formato COP/es)
      var s = v.toLocaleString('es-CO', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
      // reemplaza cualquier variante del placeholder de Shopify (amount, amount_no_decimals,
      // amount_with_comma_separator, amount_with_space_separator, etc.)
      return moneyFormat.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, s);
    }

    var stockEl = root.querySelector('[data-mt-stock]');

    function updateStock(v) {
      if (!stockEl || !v) return;
      var low = parseInt(stockEl.dataset.low, 10) || 6;
      var max = parseInt(stockEl.dataset.max, 10) || 20;
      var qty = typeof v.qty === 'number' ? v.qty : 0;
      var txtEl = stockEl.querySelector('[data-mt-stock-t]');
      var bar = stockEl.querySelector('[data-mt-stock-bar]');
      var isLow = qty > 0 && qty <= low;
      stockEl.classList.toggle('mt-stock--low', isLow || qty <= 0);
      if (txtEl) {
        var t;
        if (!v.available || qty <= 0) t = stockEl.dataset.tOut;
        else if (isLow) t = stockEl.dataset.tLow;
        else t = stockEl.dataset.tOk;
        txtEl.textContent = (t || '').replace('[n]', qty);
      }
      if (bar) {
        var pct = Math.round((qty / max) * 100);
        if (pct > 100) pct = 100;
        if (pct < 6 && qty > 0) pct = 6;
        if (qty <= 0) pct = 0;
        bar.style.width = pct + '%';
      }
    }

    function selectVariant(v) {
      if (!v) return;
      updateStock(v);
      if (idInput) idInput.value = v.id;
      if (priceEl) {
        var html = formatMoney(v.price);
        if (v.compare_at_price && v.compare_at_price > v.price) {
          html = '<del>' + formatMoney(v.compare_at_price) + '</del>' + formatMoney(v.price);
        }
        priceEl.innerHTML = html;
      }
      if (addBtn) {
        if (v.available) { addBtn.removeAttribute('disabled'); addBtn.querySelector('[data-mt-add-t]') && (addBtn.querySelector('[data-mt-add-t]').textContent = addBtn.getAttribute('data-t-add') || 'Añadir al carrito'); }
        else { addBtn.setAttribute('disabled', 'disabled'); addBtn.querySelector('[data-mt-add-t]') && (addBtn.querySelector('[data-mt-add-t]').textContent = addBtn.getAttribute('data-t-sold') || 'Agotado'); }
      }
    }

    btns.forEach(function (b) {
      b.addEventListener('click', function () {
        btns.forEach(function (x) { x.classList.remove('is-active'); });
        b.classList.add('is-active');
        var vid = parseInt(b.dataset.vid, 10);
        var v = variants.filter(function (x) { return x.id === vid; })[0];
        selectVariant(v);
      });
    });
  }

  /* --- Aviso de envío: cuenta atrás real hasta la hora de corte (Colombia) --- */
  function initEnvio() {
    var el = document.querySelector('[data-mt-envio]');
    if (!el) return;
    var out = el.querySelector('[data-mt-envio-t]');
    if (!out) return;
    var cutoff = parseInt(el.dataset.cutoff, 10);
    if (isNaN(cutoff)) cutoff = 13;
    var DIAS = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'];

    function bogotaNow() {
      // Colombia no usa horario de verano: UTC-5 fijo
      var n = new Date();
      return new Date(n.getTime() + (n.getTimezoneOffset() * 60000) - (5 * 3600000));
    }

    function esHabil(d) { var w = d.getDay(); return w >= 1 && w <= 5; }

    function proximoDiaHabil(d) {
      var x = new Date(d.getTime());
      do { x.setDate(x.getDate() + 1); } while (!esHabil(x));
      var hoy = new Date(d.getTime());
      var difDias = Math.round((x.setHours(0, 0, 0, 0) - hoy.setHours(0, 0, 0, 0)) / 86400000);
      if (difDias === 1) return 'mañana';
      return 'el ' + DIAS[new Date(x).getDay()];
    }

    function tick() {
      var b = bogotaNow();
      var antesDelCorte = esHabil(b) && b.getHours() < cutoff;

      if (antesDelCorte) {
        var corte = new Date(b.getTime());
        corte.setHours(cutoff, 0, 0, 0);
        var ms = corte - b;
        var h = Math.floor(ms / 3600000);
        var m = Math.floor((ms % 3600000) / 60000);
        var s = Math.floor((ms % 60000) / 1000);
        var t = h > 0 ? (h + 'h ' + m + 'm') : (m + 'm ' + s + 's');
        out.innerHTML = (el.dataset.tHoy || '').replace('[t]', '<b>' + t + '</b>');
      } else {
        out.innerHTML = (el.dataset.tManana || '').replace('[d]', proximoDiaHabil(b));
      }
    }

    tick();
    setInterval(tick, 1000);
  }

  /* --- Barra de aviso: rota los mensajes cada X segundos --- */
  function initAnuncio() {
    var root = document.querySelector('[data-mt-anuncio]');
    if (!root) return;
    var slides = root.querySelectorAll('.mt-anuncio__slide');
    if (slides.length < 2 || reduce) return;
    var ms = parseInt(root.dataset.interval, 10);
    if (isNaN(ms) || ms < 1000) ms = 5000;
    var i = 0;
    setInterval(function () {
      slides[i].classList.remove('is-active');
      i = (i + 1) % slides.length;
      slides[i].classList.add('is-active');
    }, ms);
  }

  /* --- Burbuja flotante de reseñas: una a la vez, fija mientras se navega --- */
  function initSocialBubble() {
    var el = document.getElementById('mtBubble');
    if (!el) return;
    var dataEl = document.getElementById('mtBubbleData');
    if (!dataEl) return;
    var items;
    try { items = JSON.parse(dataEl.textContent); } catch (e) { return; }
    if (!items || !items.length) return;

    var textEl = document.getElementById('mtBubbleText');
    var byEl = document.getElementById('mtBubbleBy');
    var closeBtn = document.getElementById('mtBubbleClose');
    var i = 0;
    var dismissed = false;
    var rotateTimer = null;

    try {
      if (sessionStorage.getItem('mtBubbleDismissed') === '1') dismissed = true;
    } catch (e) {}
    if (dismissed) return;

    var interval = Math.max(4, parseInt(window.mtBubbleInterval, 10) || 7) * 1000;
    var delay = Math.max(0, parseInt(window.mtBubbleDelay, 10) || 4) * 1000;

    function render() {
      textEl.textContent = '“' + items[i].text + '”';
      byEl.textContent = items[i].author;
    }

    function show() {
      if (dismissed) return;
      render();
      el.classList.add('is-visible');
    }

    function next() {
      if (dismissed) return;
      el.classList.remove('is-visible');
      setTimeout(function () {
        if (dismissed) return;
        i = (i + 1) % items.length;
        show();
      }, 400);
    }

    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        dismissed = true;
        el.classList.remove('is-visible');
        if (rotateTimer) clearInterval(rotateTimer);
        try { sessionStorage.setItem('mtBubbleDismissed', '1'); } catch (e) {}
      });
    }

    setTimeout(function () {
      if (dismissed) return;
      show();
      rotateTimer = setInterval(next, interval);
    }, delay);
  }

  function boot() {
    initReveals();
    initMarquee();
    initPdpGallery();
    initPdpVariants();
    initEnvio();
    initAnuncio();
    initSocialBubble();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
